import React, {useEffect, useState} from 'react';
import {
    ListItemAvatar,
    ListItemButton,
    ListItemText,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import NotInformation from '../../../../../components/NotInformation';
import CustomModal from '../../../../../components/Modal/CustomModal';
import CustomListItem from '../../../../../components/CustomListItem';
import {UseCameraIcon} from '../../../../../components/buttons/IconButtons';
import {CustomStyleListItemButton} from '../../../../../components/Styles';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param boolean open: Variable to control the modal's visibility
 * @param event onClose:  event to close modal
 * @param state setSelectedCamera: Variable for storing the selected camera.
 * @param state setSelectCameraDialogShow: It can be set to 'd-none' to toggle the modal's display state.
 * @param state setDisplayModal: State management to ensure only one modal is visible at a time.
 */
const SelectCamera = (
    {
        open,
        onClose,
        setSelectedCamera,
        setSelectCameraDialogShow,
        setDisplayModal=null
    }
) => {
    const { t } = useTranslation();

    const [cameras, setCameras] = useState([]);

    const fetchCameras = async () => {
        const mediaDevices = await navigator.mediaDevices.enumerateDevices();
        const videoDevices = mediaDevices.filter((device) => device.kind === 'videoinput');
        setCameras(videoDevices);
    };

    useEffect(() => {
        fetchCameras();

        const handleDeviceChange = () => {
            fetchCameras();
        };

        navigator.mediaDevices.addEventListener('devicechange', handleDeviceChange);

        return () => {
            navigator.mediaDevices.removeEventListener('devicechange', handleDeviceChange);
        };
    }, [open]);

    const handleListCameraClick = (item) => {
        if(setDisplayModal)
            setDisplayModal("")

        setSelectedCamera(item);
        setSelectCameraDialogShow(false);
    };

    return (
        <CustomModal
            title={'select_a_camera'}
            size='xs'
            show={open}
            onHide={() => {
                if(setDisplayModal)
                    setDisplayModal("")

                onClose();
            }}
            cancelButton={false}
            confirmButton={false}
            classNameBody="pt-2"
        >
            <div className='row'>
            {cameras.length <= 0 ? <NotInformation text={t('no_information')} card={false} />
                :
                <>
                    { cameras.map((camera, index) => (
                        <CustomListItem
                            key={index}
                            index={index + 1}
                            classes='custom-class'
                            id={`btn_sc_${index}`}
                        >
                            <ListItemButton onClick={() => handleListCameraClick(camera)} sx={CustomStyleListItemButton}>
                                <ListItemText primary={camera.label || `Camera ${index + 1}`} />
                                <ListItemAvatar>
                                    <UseCameraIcon />
                                </ListItemAvatar>
                            </ListItemButton>
                        </CustomListItem>
                    ))}
                </>
            }
            </div>
        </CustomModal>
    );
};

export default SelectCamera;
